import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Button, Col, Row, Table } from "react-bootstrap";
import NumberFormat from "react-number-format";
import useApiClient, { apiRoutes } from "../../../hooks/apiClient";
import Id from "../../../components/Formatters/Id";
import IE from "../../../components/Formatters/IE";
import FileDownloader from "../../../components/UI/Button/FileDownloader";
import { formatarData } from "../../../components/Formatters/DateTime";

const DetalheCobranca = (id) => {
  const [dados, setDados] = useState({});
  const [semDados, setSemDados] = useState(false);
  const [cobranca, setCobranca] = useState({});
  const { request, data, errors, isLoading } = useApiClient();
  const { request: requestDownload, data: dataDownload } = useApiClient();

  useEffect(() => {
    setCobranca(id);
  }, [id]);

  useEffect(() => {
    request(apiRoutes.fiscalizacao.procedimentoFiscal.detalheCobranca, { sqCobranca: cobranca.id });

    const paramsCobranca = { sqCobranca: cobranca.id };
    requestDownload(apiRoutes.fiscalizacao.procedimentoFiscal.downloadCobranca, paramsCobranca);
  }, [cobranca, request, requestDownload]);

  useEffect(() => {
    if ((!data && !errors) || isLoading) return;

    if (data && data.result) {
      setDados(data.result);
      setSemDados(false);
    }

    if (!data) {
      setSemDados(true);
    }

    if (errors) {
      toast.error(errors.message);
    }
  }, [data, errors, isLoading]);

  function StatusCobranca() {
    switch (dados.situacaoCobranca) {
      case "A":
        return "Aberta";
      case "H":
        return "Homologada";
      case "G":
        return "Gerada";
      case "E":
        return "Encerrada";
      default:
        return "-";
    }
  }

  function StatusAndamento(andamento) {
    switch (andamento.situacao) {
      case "A":
        return "Aberto";
      case "H":
        return "Homologado";
      case "G":
        return "Gerado";
      case "E":
        return "Encerrado";
      default:
        return "-";
    }
  }

  return (
    <>
      {/* Cabeçalho da Página */}
      <div className="row">
        <div className="col-lg-12">
          {!semDados && (
            <div className="card shadow mb-4">
              <div className="card-header py-3">
                <Row>
                  <Col sm="12" className="d-flex">
                    <h5 className="m-0 font-weight-bold text-primary d-flex align-items-center">
                      Cobrança nº {cobranca.id}
                    </h5>
                    <FileDownloader
                      binario={dataDownload}
                      tooltip={`Visualizar cobrança ${cobranca.id}`}
                      className="ml-2"
                      nomeArquivo={`ResultadoCobranca-${cobranca.id}.html`}
                    />
                  </Col>
                  <Col sm="1" className="text-right" />
                </Row>
              </div>
              <div className="card-body">
                <Row className="bg-gray-100 border-bottom-gray py-2">
                  <Col sm="7">
                    Razão Social
                    <br />
                    <b>{dados.nomeContribuinte}</b>
                  </Col>
                  <Col sm="3">
                    CNPJ/CPF
                    <br />
                    <b>
                      <Id value={dados.documentoContribuinte} />
                    </b>
                  </Col>
                  <Col sm="2">
                    Inscrição Estadual
                    <br />
                    <b>
                      <IE value={dados.inscricaoEstadual} empty="-" />
                    </b>
                  </Col>
                </Row>
                <Row className="bg-gray-100 border-bottom-gray py-2">
                  <Col sm="7">
                    Débito Final
                    <br />
                    <b>
                      <NumberFormat
                        value={dados.valorDebitosFinal}
                        displayType="text"
                        thousandSeparator="."
                        decimalSeparator=","
                        allowNegative={false}
                        decimalScale={2}
                        fixedDecimalScale
                      />
                    </b>
                  </Col>
                  <Col sm="3">
                    Situação Cobrança
                    <br />
                    <b>{StatusCobranca()}</b>
                  </Col>
                </Row>
                <Row className="py-2">
                  <Col sm="12">
                    <br />
                    <h6 className="m-0 font-weight-bold text-primary d-flex align-items-center">Andamentos:</h6>
                    {dados?.andamentos?.length === 0 ||
                      (dados?.andamentos?.length === undefined && <h6>Nenhum Andamento Encontrado.</h6>)}
                    {dados?.andamentos?.length > 0 && (
                      <Table>
                        <thead>
                          <tr>
                            <th sm="1">Nº</th>
                            <th sm="6">Descrição</th>
                            <th sm="3">Executor</th>
                            <th sm="1">Inclusão</th>
                            <th sm="1">Situação</th>
                          </tr>
                        </thead>
                        <tbody>
                          {dados.andamentos.map((andamento) => (
                            <tr>
                              <td>{andamento.sequencial}</td>
                              <td>{andamento.nomeAtividade}</td>
                              <td>{andamento.nomeExecutor}</td>
                              <td>{formatarData(andamento.dataProcedimento)}</td>
                              <td>{StatusAndamento(andamento)}</td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    )}
                  </Col>
                </Row>

                <Row style={{ marginTop: "30px" }} className="py-2">
                  <Col sm="2">
                    <Button
                      variant="danger"
                      onClick={() => {
                        window.close();
                      }}
                    >
                      Voltar
                    </Button>
                  </Col>
                </Row>
              </div>
            </div>
          )}
          {semDados && (
            <div className="card shadow mb-4">
              <div className="card-header py-3">
                <Row>
                  <h6 className="m-0 font-weight-bold text-primary d-flex align-items-center">
                    Nenhuma denúncia encontrada.
                  </h6>
                </Row>
                <Row style={{ marginTop: "30px" }} className="py-2">
                  <Col sm="2">
                    {cobranca.id == null ? (
                      <Button
                        variant="danger"
                        onClick={() => {
                          window.close();
                        }}
                      >
                        Voltar
                      </Button>
                    ) : null}
                  </Col>
                </Row>
              </div>
            </div>
          )}
        </div>
      </div>
      {/* fim da row */}
    </>
  );
};

export default DetalheCobranca;
